// extracted by mini-css-extract-plugin
export var lg = "_12-4";
export var md = "_12-3";
export var sm = "_12-2";
export var xs = "_12-1";
export var xxs = "_12-0";